import { render } from "./EditIndustrySectorsModal.vue?vue&type=template&id=19717096&scoped=true"
import script from "./EditIndustrySectorsModal.vue?vue&type=script&lang=js"
export * from "./EditIndustrySectorsModal.vue?vue&type=script&lang=js"

import "./EditIndustrySectorsModal.vue?vue&type=style&index=0&id=19717096&scoped=true&lang=css"

import exportComponent from "/var/www/matchmaker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19717096"]])

export default __exports__